/**
 * Whether the contact person section has to be opened now. Already open means
 * no: the caller runs on every render, and a redundant open loops the form.
 */
export function shouldOpenContactPersonSection({
  isOpen,
  shouldAutoOpenFromSuggestions,
  contactPersonMode,
}: {
  isOpen: boolean;
  shouldAutoOpenFromSuggestions: boolean;
  contactPersonMode: "none" | "existing" | "new";
}): boolean {
  if (isOpen) return false;

  return shouldAutoOpenFromSuggestions || contactPersonMode !== "none";
}
